module.exports = __webpack_public_path__ + "static/media/Tile Image 5.ea0deb77.png";